// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-result-wrapper{padding:.5rem;padding-top:1rem;border-bottom:1px solid #d3d3d3}.search-result-wrapper:nth-child(2n){background:#fafafa}.search-result-wrapper:hover{background:#f5f5f5}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
